import React, { memo, useCallback, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { TablesNav, TablesTab } from './ProductAttributesNav.styles';

function ProductAttributesNav({ navs }) {
  const [isDown, setIsDown] = useState(false);
  const [isMoving, setIsMoving] = useState(false);
  const [startX, setStartX] = useState(null);
  const [scrollLeft, setScrollLeft] = useState(null);

  const tablesNavRef = useRef();

  const scrollToAttr = useCallback((id) => {
    const anchor = document.querySelector(`#${id}`);
    const y = anchor.getBoundingClientRect().top + window.pageYOffset - 79;

    window.scrollTo({ top: y, behavior: 'smooth' });
  }, []);

  const handleMouseDown = useCallback((e) => {
    setIsDown(true);
    setStartX(e.pageX - tablesNavRef?.current?.offsetLeft);
    setScrollLeft(tablesNavRef?.current?.scrollLeft);
  }, []);

  const handleMouseLeaveUp = useCallback(() => {
    setIsDown(false);
    setIsMoving(false);
  }, []);

  const handleMouseMove = useCallback(
    (e) => {
      if (!isDown) return;

      e.preventDefault();
      const x = e.pageX - tablesNavRef?.current?.offsetLeft;
      const walk = x - startX;

      tablesNavRef.current.scrollLeft = scrollLeft - walk;
      setIsMoving(true);
    },
    [isDown]
  );

  return (
    <TablesNav
      ref={tablesNavRef}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeaveUp}
      onMouseUp={handleMouseLeaveUp}
      onMouseMove={handleMouseMove}
    >
      {navs.map((item) => (
        <TablesTab
          key={item}
          $isMoving={isMoving}
          onClick={() => scrollToAttr(item)}
        >
          <FormattedMessage id={`details.table.title.${item}`} />
        </TablesTab>
      ))}
    </TablesNav>
  );
}

ProductAttributesNav.propTypes = {
  navs: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default memo(ProductAttributesNav);
